// extracted by mini-css-extract-plugin
module.exports = {"NextButton":"NextButton__3fqd8","loading":"loading__TOuvL"};